import * as React from 'react';

import { bind } from 'decko';
import { block } from 'bem-cn';

import {Button as MuiButton, ButtonProps, TooltipProps} from '@material-ui/core';

import { Tooltip } from 'shared/view/elements';

import './Button.scss';

const b = block('button');

interface IOwnProps {
  onClick?(): void;
  disabled?: boolean;
  tooltip?: string;
  tooltipProps?: {
    placement?: TooltipProps['placement'];
    withoutWrapper?: boolean
  }
}

class Button extends React.Component<IOwnProps & ButtonProps> {

  render() {
    const { children, tooltip, disabled = false, tooltipProps, ...restProps } = this.props;
    const button = (
      <MuiButton
        color="primary"
        variant="contained"
        disabled={disabled}
        onClick={this.onClick}
        {...restProps}
      >
        {children}
      </MuiButton>
    );

    if (!tooltip || disabled) {
      return <div className={b()}>{button}</div>;
    }

    return (
      <Tooltip placement={tooltipProps?.placement || 'top-start'} title={tooltip}>
        {tooltipProps?.withoutWrapper ? (
          button
        ) : (
          <div>
            <div className={b()}>{button}</div>
          </div>
        )}
      </Tooltip>
    )
  }

  @bind
  private onClick(event: React.FormEvent<HTMLButtonElement>) {
    const { onClick } = this.props;
    event.preventDefault();
    if (onClick) {
      onClick();
    }
  }
}

export { Button };
